// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K0nA","content":"styles_content__39XtW","row":"styles_row__rknEa","footer":"styles_footer__1jRBw","phraseLength":"styles_phraseLength__1WA9L"};